import React from "react";
import { ModalNew } from "components/Modal/ModalNew";
import { ContactDetails } from "./ContactDetails";
import FallbackImage from "../FallbackImage/FallbackImage";
import { DEFAULT_IMAGE_AVATAR } from "utils/constants";

type Company = {
	id: number;
	company_number?: string;
	description?: string;
	email?: string;
	locations?: Array<{
		address?: string;
	}>;
	logo_path?: string;
	name: string;
	website?: string;
};

type ContactDetailsModalProps = {
	company: Company | null;
	isOpen: boolean;
	onClose: () => void;
};

export const ContactDetailsModal = ({
	isOpen,
	onClose,
	company,
}: ContactDetailsModalProps) => {
	return (
		<ModalNew
			isOpen={isOpen}
			onClose={onClose}
			headerContent="Contact Details"
			width="600px"
		>
			{company && (
				<div className="space-y-4">
					<div className="mb-6 flex items-center gap-4">
						{company.logo_path && (
							<FallbackImage
								src={company.logo_path}
								alt={company.name}
								fallbackSrc={DEFAULT_IMAGE_AVATAR}
								className="size-12 rounded-full bg-white object-contain shadow-lg"
							/>
						)}
						<h3 className="text-xl font-semibold text-gray-900">
							{company.name}
						</h3>
					</div>
					<ContactDetails
						details={null}
						phone={company.company_number}
						email={company.email}
						address={company.locations?.[0]?.address}
						website={company.website}
					/>
				</div>
			)}
		</ModalNew>
	);
};
